import { BoundTextAreaField, BoundTextAreaFieldProps, Only, TextFieldXss } from "@homebound/beam";
import { Observer } from "mobx-react";
import { ObjectState } from "src/utils/formState";
import { AiFieldProposalFormValue } from "./utils/aiFieldProposalForm";
import { parseAiString, pendingProposedValue, resolveAiProposalStatus } from "./utils/bindAiProposal";

export type BoundAiTextAreaFieldProps<X> = Omit<BoundTextAreaFieldProps<X>, "proposedValue"> & {
  aiProposal?: ObjectState<AiFieldProposalFormValue>;
};

export function BoundAiTextAreaField<X extends Only<TextFieldXss, X>>(props: BoundAiTextAreaFieldProps<X>) {
  const { field, aiProposal, onChange, ...others } = props;
  // Observer wrapper needed for `aiProposal.status` / `fieldValue` so the pending proposal stays in sync.
  return (
    <Observer>
      {() => (
        <BoundTextAreaField
          field={field}
          proposedValue={pendingProposedValue(aiProposal, parseAiString)}
          onChange={(value) => {
            field.set(value);
            resolveAiProposalStatus(aiProposal, parseAiString, value);
            onChange?.(value);
          }}
          {...others}
        />
      )}
    </Observer>
  );
}
